import { FinalQuiz } from '@/types/finalQuiz';

export const mockFinalQuiz: FinalQuiz = {
  trailId: '1',
  title: 'Quiz Final: Fundamentos de IA',
  description: 'Avaliação completa dos conhecimentos adquiridos na trilha',
  totalQuestions: 5,
  passingScore: 70,
  questions: [
    {
      id: 'q1',
      module: 'Introdução à Inteligência Artificial',
      question: 'Qual é a definição mais precisa de Inteligência Artificial?',
      options: [
        {
          id: 'q1-a',
          letter: 'A',
          text: 'Programas que apenas seguem instruções pré-definidas sem capacidade de adaptação.',
          isCorrect: false,
        },
        {
          id: 'q1-b',
          letter: 'B',
          text: 'Sistemas computacionais capazes de realizar tarefas que normalmente requerem inteligência humana.',
          isCorrect: true,
        },
        {
          id: 'q1-c',
          letter: 'C',
          text: 'Robôs humanoides que imitam o comportamento humano em todos os aspectos.',
          isCorrect: false,
        },
        {
          id: 'q1-d',
          letter: 'D',
          text: 'Softwares de automação simples para tarefas repetitivas.',
          isCorrect: false,
        },
      ],
    },
    {
      id: 'q2',
      module: 'Tipos de Aprendizado de Máquina',
      question: 'Qual tipo de aprendizado de máquina utiliza dados rotulados para treinamento?',
      options: [
        {
          id: 'q2-a',
          letter: 'A',
          text: 'Aprendizado Não-Supervisionado',
          isCorrect: false,
        },
        {
          id: 'q2-b',
          letter: 'B',
          text: 'Aprendizado Supervisionado',
          isCorrect: true,
        },
        {
          id: 'q2-c',
          letter: 'C',
          text: 'Aprendizado por Reforço',
          isCorrect: false,
        },
        {
          id: 'q2-d',
          letter: 'D',
          text: 'Aprendizado Semi-Automático',
          isCorrect: false,
        },
      ],
    },
    {
      id: 'q3',
      module: 'Como os modelos aprendem',
      question: 'No contexto de aprendizado de máquina, o que define melhor o conceito de "Backpropagation"?',
      options: [
        {
          id: 'q3-a',
          letter: 'A',
          text: 'O processo de duplicar dados para aumentar a base de treinamento do modelo.',
          isCorrect: false,
        },
        {
          id: 'q3-b',
          letter: 'B',
          text: 'O mecanismo de ajuste dos pesos dos neurônios com base no erro calculado na saída.',
          isCorrect: true,
        },
        {
          id: 'q3-c',
          letter: 'C',
          text: 'A fase onde o modelo é apresentado a dados que ele nunca viu anteriormente.',
          isCorrect: false,
        },
        {
          id: 'q3-d',
          letter: 'D',
          text: 'Um método de compressão de arquivos para economizar espaço em servidores de IA.',
          isCorrect: false,
        },
      ],
    },
    {
      id: 'q4',
      module: 'Redes Neurais e Deep Learning',
      question: 'O que caracteriza uma rede neural profunda (Deep Neural Network)?',
      options: [
        {
          id: 'q4-a',
          letter: 'A',
          text: 'Uma rede com apenas uma camada de neurônios.',
          isCorrect: false,
        },
        {
          id: 'q4-b',
          letter: 'B',
          text: 'Uma rede que processa dados muito rapidamente.',
          isCorrect: false,
        },
        {
          id: 'q4-c',
          letter: 'C',
          text: 'Uma rede com múltiplas camadas ocultas entre entrada e saída.',
          isCorrect: true,
        },
        {
          id: 'q4-d',
          letter: 'D',
          text: 'Uma rede que utiliza apenas dados de texto.',
          isCorrect: false,
        },
      ],
    },
    {
      id: 'q5',
      module: 'Aplicações Práticas de IA',
      question: 'Qual das seguintes aplicações é um exemplo de Processamento de Linguagem Natural (NLP)?',
      options: [
        {
          id: 'q5-a',
          letter: 'A',
          text: 'Reconhecimento facial em câmeras de segurança.',
          isCorrect: false,
        },
        {
          id: 'q5-b',
          letter: 'B',
          text: 'Análise de sentimentos em comentários de redes sociais.',
          isCorrect: true,
        },
        {
          id: 'q5-c',
          letter: 'C',
          text: 'Detecção de objetos em imagens médicas.',
          isCorrect: false,
        },
        {
          id: 'q5-d',
          letter: 'D',
          text: 'Predição de preços de ações usando séries temporais.',
          isCorrect: false,
        },
      ],
    },
  ],
};
